angular.module('angus.services').factory('hedgeService', [
    '$http',
    function($http) {
        'use strict';

        return {
            getHedgePricePlanTypeCategories: function(subscriberKey) {
                return $http.get(`api/subscriber/${subscriberKey}/hedge-price-plan-type-categories`, {apiV2: true})
                  .then(res => res.data);
            }
        };
    }
]);
